// extracted by mini-css-extract-plugin
export default {"section":"WrapperFilterSection_section__3Utzh","title":"WrapperFilterSection_title__DMMBU"};